'use client';

import { JobDetail } from '~/types/job-detail';
import { ApplicationButton } from '~/components/button/application-button';
import { FavoriteButton } from '~/components/button/job-detail-favorite-button';

interface ActionButtonsProps {
  job: JobDetail;
  isSignedIn: boolean;
  jobApplicantsJobIds: number[];
  isMobile: boolean;
  isFavorite: boolean;
  favoriteJobIds: number[];
}

export function ActionButtons({
  job,
  isSignedIn,
  jobApplicantsJobIds,
  isMobile,
  isFavorite,
  favoriteJobIds,
}: ActionButtonsProps) {
  const serviceType = job.service_type === '求人広告' ? 'ad' : 'agent';
  const isApplied = jobApplicantsJobIds.includes(job.id);

  return (
    <div className="p-job-detail__buttons">
      {!job.closing && (
        <>
          <FavoriteButton
            jobId={job.id}
            isFavorite={isFavorite}
            isSignedIn={isSignedIn}
            isMobile={isMobile}
            favoriteJobIds={favoriteJobIds}
          />
          <ApplicationButton
            job={job}
            isMobile={isMobile}
            isApplied={isApplied}
            isSignedIn={isSignedIn}
            serviceType={serviceType}
            position="center"
          />
        </>
      )}
    </div>
  );
}
